import axiosInstance from '../config/axios.js';

const API_BASE = '/analytics';

const analyticsService = {
  // Get Profit & Loss Analytics
  getProfitLoss: async (params = {}) => {
    const response = await axiosInstance.get(`${API_BASE}/profit-loss`, { params });
    return response.data;
  },

  // Get Shipment Analytics
  getShipmentAnalytics: async (params = {}) => {
    const response = await axiosInstance.get(`${API_BASE}/shipments`, { params });
    return response.data;
  },

  // Get Vehicle Analytics
  getVehicleAnalytics: async (params = {}) => {
    const response = await axiosInstance.get(`${API_BASE}/vehicles`, { params });
    return response.data;
  },

  // Get Missing & Returned Analytics
  getMissingReturnedAnalytics: async (params = {}) => {
    const response = await axiosInstance.get(`${API_BASE}/missing-returned`, { params });
    return response.data;
  },

  // Get User Performance Analytics
  getUserPerformance: async (params = {}) => {
    const response = await axiosInstance.get(`${API_BASE}/user-performance`, { params });
    return response.data;
  },

  // Get Dashboard Summary
  getDashboardSummary: async () => {
    const response = await axiosInstance.get(`${API_BASE}/dashboard`);
    return response.data;
  },

  // Get Inventory Analytics (NEW)
  getInventoryAnalytics: async (params = {}) => {
    const response = await axiosInstance.get(`${API_BASE}/inventory`, { params });
    return response.data;
  },

  // Get Commission Analytics
  getCommissionAnalytics: async (params = {}) => {
    const response = await axiosInstance.get(`${API_BASE}/commission`, { params });
    return response.data;
  }
};

export default analyticsService;